// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

function Venue2394(props) {
    return (
        <svg
            id="_x32_394"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 250 250"
            style={{
                enableBackground: 'new 0 0 250 250',
            }}
            xmlSpace="preserve"
            {...props}
        >
            <style type="text/css">
                {
                    "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n\t.st11{display:none;}\n\t.st12{display:inline;}\n\t.st13{font-size:4.995px;}\n\t.st14{fill:none;stroke:#B3B3B3;stroke-miterlimit:3.92;}\n\t.st15{fill:none;stroke:#B7B7B7;}\n\t.st16{fill:none;stroke:#B3B3B3;stroke-width:0.25;stroke-miterlimit:10;}\n"
                }
            </style>
            <g id="DET">
                <g id="compass">
                    <path
                        className="st0"
                        d="M233.3,193.2l-5.2,7.5l-6.6,4.6l4.3-6.8L233.3,193.2z"
                    />
                    <path
                        className="st1"
                        d="M237.8,188.3c6.2,5.9,6.4,15.8,0.4,21.9c-5.9,6.2-15.8,6.4-21.9,0.4c-6.2-5.9-6.4-15.8-0.4-21.9 C221.8,182.6,231.6,182.4,237.8,188.3z M217.2,209.8c5.6,5.4,14.6,5.2,20.1-0.4c5.4-5.6,5.2-14.6-0.4-20.1 c-5.6-5.4-14.6-5.2-20.1,0.4C211.4,195.3,211.6,204.3,217.2,209.8z"
                    />
                    <path
                        className="st0"
                        d="M224,199.6c0-1.6,1.3-3,2.9-3c1.6,0,3,1.3,3,2.9c0,1.6-1.3,3-2.9,3C225.4,202.5,224.1,201.2,224,199.6z  M221.5,207l-2.1,2.2l-0.3-0.3l0.5-2.5l-1.5,1.5l-0.4-0.4l2.1-2.2l0.3,0.3l-0.5,2.5l1.5-1.5L221.5,207z"
                    />
                    <path
                        className="st2"
                        d="M225.4,199.6c0-0.9,0.7-1.7,1.6-1.7c0.9,0,1.7,0.7,1.7,1.6c0,0.9-0.7,1.7-1.6,1.7 C226.1,201.2,225.4,200.5,225.4,199.6z"
                    />
                </g>
                <g id="distances">
                    <text
                        id="right"
                        transform="matrix(1 0 0 1 223.5352 115.2515)"
                        className="st3 st4 st5"
                    >
                        328
                    </text>
                    <text
                        id="right-center"
                        transform="matrix(1 0 0 1 186.1553 62.4839)"
                        className="st3 st4 st5"
                    >
                        365
                    </text>
                    <text
                        id="center"
                        transform="matrix(1 0 0 1 114.6646 27.2437)"
                        className="st3 st4 st5"
                    >
                        412
                    </text>
                    <text
                        id="left"
                        transform="matrix(1 0 0 1 5.5811 114.6094)"
                        className="st3 st4 st5"
                    >
                        341
                    </text>
                </g>
                <g id="field" transform="matrix(.98 0 0 -.98 250 420)">
                    <path
                        id="Outfield_00000052072025152570459770000000919102578477963430_"
                        className="st6"
                        d="M-229.8,323.9l0.6,3.1l2.8,0.8l1.8,1.8 l1.8,1.7l1.8,1.8l1.8,1.8l1.8,1.9l1.8,1.8l1.8,1.8l1.8,1.9l1.9,1.8l1.9,1.9l1.9,1.9l1.9,1.9l1.9,1.9l1.9,1.9l2,2l2,2l2,2l2,2l2,2 l2.1,2.1l2.1,2.1l2.2,2.1l2.2,2.2l2.2,2.2l2.3,2.3l2.3,2.3l2.3,2.3l2.4,2.4l2.4,2.4l2.5,2.5l2.5,2.5l2.7,2.2l2.9,1.3l2.9,1.3 l2.9,1.3h3.1h3.1h3.1h3.1h3.1h3.1h3.1h3.1h3.1h3.1h3.1h3.1h3.1h3.1h3.1h3.1h3.1l2.9-1.2l2.9-1.2l2.9-1.2l2.9-1.2l2.5-2.5l2.5-2.5 l2.4-2.4l2.4-2.4l2.3-2.3l2.3-2.3l2.3-2.3l1.4-4.3l1-4.9l1.9-2.5l2-2l2-2l2-2l2-2l2-2l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.8l1.9-1.9 l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8l2-1.6l1.7-1.8l1.8-1.8l1.8-1.7l1.7-1.9l0.9-2.6l0.1-3.4L-28,316l-21.2-21.4v-14.1 l-26-38.6c0,0-15.6-19-30.6-34.3l0,0c-15-15.4-30.8-9.1-37.4-2.8s-32.7,33.2-32.7,33.2l-36,59.6l0.3,3.7l-17.8,18L-229.8,323.9z"
                    />
                    <path
                        id="grass_1_"
                        className="st3"
                        d="M-141.5,213c-5.9,5.6-27.4,28.5-31.5,32.7l-24.3,40.7l-8.1,12.9l-0.3,6.1l-15.8,15.8l62.7,63.1 c0,0,2.1,1.7,4.3,3s4.5,2,4.5,2l48.7-0.6l7.6-3.3l14.4-13.9l0.9-1.1l1.6-8.5l21.2-20.9l16.7-16.9l2-2.1l-0.4-2.2l0.4-2.1 L-56,298.4l0.6-14.2l-14.5-21.5l-13.6-19.2c-0.1-0.1-14.9-15.2-29.6-30.3c-2.1-2.1-8.7-8.7-14.7-8.5 C-134.7,205.1-140.9,212.4-141.5,213z"
                    />
                    <path
                        id="infield_sand_00000034799664575275343940000001562901586088807355_"
                        className="st6"
                        d="M-87.9,258.5l-1,1 c-5.1,16.3-20.4,28.3-38.5,28.3s-33.4-11.9-38.5-28.3l-1-1l33.4-33.4v-3.3l6.2-6.3l6.1,6.1v3.5L-87.9,258.5z M-126.6,227.3v17.9 h-1.3v-17.9h-3.9l-18,18l2.6,2.6c1.6,1.5,1.6,4.1,0,5.7l17.1,17.1c0.8-0.5,1.8-0.8,2.8-0.8s2,0.3,2.8,0.8l17.1-17.1 c-1.6-1.6-1.6-4.2,0-5.7l2.6-2.6l-18-18H-126.6z"
                    />
                </g>
                <g id="persistent_1_">
                    <g id="mound_1_">
                        <path
                            id="pitching-mound_1_"
                            className="st6"
                            d="M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
                        />
                        <path
                            id="pitching-rubber_1_"
                            className="st7"
                            d="M123.2,176.6h4v1.6h-4V176.6z"
                        />
                    </g>
                    <g id="lines_1_">
                        <path
                            id="left-foul-line_1_"
                            className="st8"
                            d="M125.2,203.2L24.5,102.6"
                        />
                        <path
                            id="right-foul-line_2_"
                            className="st8"
                            d="M125.2,203.2l96.5-96.6"
                        />
                    </g>
                    <g id="bases_2_">
                        <rect
                            id="third-base_2_"
                            x={99.2}
                            y={175.1}
                            transform="matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)"
                            className="st9"
                            width={3}
                            height={3}
                        />
                        <rect
                            id="first-base_2_"
                            x={148.1}
                            y={175.2}
                            transform="matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)"
                            className="st9"
                            width={3}
                            height={3}
                        />
                        <rect
                            id="second-base_2_"
                            x={123.7}
                            y={148.6}
                            transform="matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)"
                            className="st10"
                            width={3}
                            height={3}
                        />
                        <polygon
                            id="home_2_"
                            className="st7"
                            points="126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
                        />
                    </g>
                </g>
            </g>
            <g id="grid" className="st11">
                <g className="st12">
                    <g id="numbers">
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 90.9866 184.0761)"
                            className="st4 st13"
                        >
                            90
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 56.4654 153.8222)"
                            className="st4 st13"
                        >
                            200
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 71.0452 168.4018)"
                            className="st4 st13"
                        >
                            150
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 80.378 177.7343)"
                            className="st4 st13"
                        >
                            120
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 41.6028 138.9599)"
                            className="st4 st13"
                        >
                            250
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 27.4712 123.956)"
                            className="st4 st13"
                        >
                            300
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 12.6905 109.1753)"
                            className="st4 st13"
                        >
                            350
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 75.9258)"
                            className="st4 st13"
                        >
                            400
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 49.4311)"
                            className="st4 st13"
                        >
                            450
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 24.6201)"
                            className="st4 st13"
                        >
                            500
                        </text>
                    </g>
                    <g id="surface29_2_">
                        <path className="st14" d="M125.5,203.8l-148-148" />
                        <path className="st14" d="M124.8,203.8l148-148" />
                        <path className="st15" d="M125.1,203.5L45.4,10.9" />
                        <path className="st15" d="M125.1,203.5V-4.9" />
                        <path className="st15" d="M125.1,203.5l79.8-192.6" />
                    </g>
                    <path
                        id="_x31_00-line"
                        className="st14"
                        d="M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
                    />
                    <path
                        id="_x32_00-line_2_"
                        className="st14"
                        d="M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5c23,0,43.8,9.3,58.8,24.4"
                    />
                    <path
                        id="_x39_0-line_2_"
                        className="st14"
                        d="M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1c10.4,0,19.7,4.2,26.5,11"
                    />
                    <path
                        id="_x31_20-line"
                        className="st14"
                        d="M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4c17.2,0,32.8,7,44.1,18.3"
                    />
                    <path
                        id="_x32_50-line"
                        className="st14"
                        d="M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6c28.7,0,54.7,11.6,73.6,30.5"
                    />
                    <path
                        id="_x33_00-line"
                        className="st14"
                        d="M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
                    />
                    <path
                        id="_x33_50-line"
                        className="st14"
                        d="M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1c40.2,0,76.6,16.3,103,42.7"
                    />
                    <path
                        id="_x34_50-line"
                        className="st14"
                        d="M-7.4,70.9c33.9-34,80.8-55,132.6-55c51.7,0,98.6,21,132.5,54.9"
                    />
                    <path
                        id="_x34_00-line_1_"
                        className="st14"
                        d="M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9c46,0,87.6,18.6,117.7,48.8"
                    />
                    <path
                        id="_x35_00-line"
                        className="st14"
                        d="M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9c57.5,0,109.5,23.3,147.2,61"
                    />
                </g>
                <g className="st12">
                    <rect
                        x={125.2}
                        y={16}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={18}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={20.1}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={22.2}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={24.3}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={26.3}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={28.4}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={30.5}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={32.6}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={34.6}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                </g>
            </g>
        </svg>
    )
}
export default Venue2394
